import { FormatNames } from '@anm/api/modules/hosting';

type Format = {
  name: FormatNames;
  iconSrc: string;
};

const VIEW_FORMATS: Format[] = [
  {
    name: 'mobile',
    iconSrc: 'images/icons/formats/mobile.svg'
  },
  {
    name: 'fit',
    iconSrc: 'images/icons/formats/fit.svg'
  },
  {
    name: 'fullscreen',
    iconSrc: 'images/icons/formats/fullscreen.svg'
  }
];

export default VIEW_FORMATS;
